import logo from './logo.svg';
import './App.css';
import NavbarHeader from './components/NavbarHeader';
import Home from './components/Home';
import AppRoute from './AppRoute';
import Footer from './components/Footer';
import TermsGate from './components/TermsGate';

function App() {
  return (
    <>
    <NavbarHeader></NavbarHeader>
    <AppRoute></AppRoute>
    <TermsGate></TermsGate>
    {/* <Footer></Footer> */}
    </>
  );
}

export default App;
